import src from "IMAGE";
export default { src, width: 500, height: 500, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAANUlEQVR42r3OMQ4AIAgEQQ9OMEEtNCb+/6U+wJ6tt5hS8nIRO26rkgTwD420O8fuEa6qSLQ9dmgA6Uw02Q0AAAAASUVORK5CYII="};
